import { _BaseSectionButtonData, ISectionButtonData, sectionButtonData } from "./_base-section-button"

export class SectionButtonCancel 
    extends _BaseSectionButtonData
{
    protected constructor(buttonData?: Partial<SectionButtonCancel>){
        super(buttonData);
        
        this[sectionButtonData.disabled] = false;
        this[sectionButtonData.hide] = false;
        this[sectionButtonData.tooltip] = 'cancel';
    }

    static create(buttonData?: Partial<ISectionButtonData>): ISectionButtonData | null {
        return !!buttonData ? new SectionButtonCancel(buttonData) : null;
    }
}
